import React, { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Box, createStyles, Grid, makeStyles } from '@material-ui/core';
import { fetchHtml } from '../../../api/settings';
import Spin from '../Spin/Spin';

const useStyles = makeStyles(() =>
    createStyles({
        container: {
            '& p': {
                wordBreak: 'break-word',
            },
        },
    })
);

interface Props {
    url: string;
}

const WysywygToHtml = ({ url }: Props) => {
    const classes = useStyles();
    const [html, setHtml] = useState('');
    const [loading, setLoading] = useState(true);
    const { enqueueSnackbar } = useSnackbar();
    const load = useCallback(async () => {
        try {
            setHtml(await fetchHtml(url));
        } catch (e) {
            enqueueSnackbar('Ошибка при получении данных', {
                variant: 'error',
            });
        } finally {
            setLoading(false);
        }
    }, [enqueueSnackbar, url]);

    useEffect(() => {
        load();
    }, [load]);

    return (
        <Box position="relative" textAlign="center">
            {loading && <Spin />}
            <Grid container>
                <Grid item lg={8} md={10} xs={11} style={{ margin: '0 auto' }}>
                    <div className={classes.container} dangerouslySetInnerHTML={{ __html: html }} />
                </Grid>
            </Grid>
        </Box>
    );
};

export default WysywygToHtml;
